import { TabId } from "../user-login-sign-up-screen.tsx";
import { createContext, PropsWithChildren, useContext, useReducer, useState } from "react";
import { DialogContext } from "../../utils/dialog-context.tsx";

export interface LoginDialogState {
  initialTab: TabId;
  loginCallback?: () => PromiseLike<void>;
  loginSuccessMessage?: string;
}

export interface LoginDialogContextModel {
  state: LoginDialogState;
  update: (action: Partial<LoginDialogState>) => void;
}

const reducer = (state: LoginDialogState, action: Partial<LoginDialogState>): LoginDialogState => {
  return { ...state, ...action };
};

export const LoginDialogContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [state, update] = useReducer(reducer, { initialTab: "sign-in" });
  const [open, setOpen] = useState(false);
  return (
    <DialogContext.Provider value={{ open, setOpen }}>
      <LoginDialogContext.Provider value={{ state, update }}>{children}</LoginDialogContext.Provider>
    </DialogContext.Provider>
  );
};
export const LoginDialogContext = createContext<LoginDialogContextModel | undefined>(undefined);

export const useLoginDialogContext = () => {
  return useContext(LoginDialogContext);
};
